// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"cdcd449b","56":"aad819e4","175":"cc5c9de2","311":"4073bce9","336":"9de53867","380":"b952d7d6","384":"918847e8","417":"392175b9","665":"9c6bdd05","895":"60d5b188","912":"7ee2de3b"}[chunkId] + ".chunk.js";
};